import React from "react";
import AdminUserActivity from "./AdminUserActivity";
import AdminUserTrust from "./AdminUserTrust";
import AdminUserNotifications from "./AdminUserNotifications";
import AdminUserFollowing from "./AdminUserFollowing";

/**
 * AdminUserOverview - Overview tab content for admin user detail page
 *
 * Displays:
 * 1. Key metrics (payment plan, team, member since, last sign in)
 *    - Payment plan and team are hidden for media users
 * 2. Trust status summary card (links to Trust tab)
 * 3. Notification health summary card (links to Notifications tab)
 * 4. Following summary card (links to Following tab)
 *
 * Note: The user header and navigation tabs are rendered by Rails partials.
 * Trust, Notification, and Following cards are composed components that fetch their own data.
 *
 * @param {boolean} isMedia - Whether this is a media user (hides promoter-specific fields)
 * @param {string} profileId - Profile ID for following data
 */
function AdminUserOverview({ userSlug, userId, profileId, isMedia }) {
  return (
    <div className="admin-user-overview">
      <AdminUserActivity userId={userId} userSlug={userSlug} mode="card" />
      <AdminUserTrust userId={userId} userSlug={userSlug} isMedia={isMedia} mode="card" />
      <AdminUserNotifications userId={userId} userSlug={userSlug} mode="card" />
      {profileId && <AdminUserFollowing profileId={profileId} userSlug={userSlug} mode="card" />}
    </div>
  );
}

export default AdminUserOverview;
